<template>
  <div id="login">
    <Modal
      title="更改手机号"
      :tapToDismiss="true"
      :onDismiss="state.dismiss"
      :showComplete="false"
      :showClose="true"
      v-on:dismiss="$emit('dismiss')"
      v-on:complete="complete"
    >
      <Phone :isComponent="true" v-on:complete="complete" />
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/popup/Modal"
import LoginComponent from "@/components/login/Main"
import Phone from "./Phone"

export default {
  name: "ChangeMobile",
  props: {
  },
  components: {
    Modal,
    LoginComponent,
    Phone
  },
  data() {
    return {
      state: {
        dismiss: false,
      },
    }
  },
  methods: {
    async complete() {
      this.state.dismiss = true
      return this.$emit("complete")
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "./modal.scss";

#login {
}
</style>
